import _extends from "@babel/runtime/helpers/extends";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useButtonClass } from "../button";
import { icons } from "./icons";
import { jsx as _jsx } from "react/jsx-runtime";
export var SocialSharingLinks = props => {
  var [url, setURL] = useState("");
  var classes = useSocialLinksClasses({
    color: props.color
  });
  useEffect(() => {
    if (window && window.location) {
      setURL(window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "") + window.location.pathname);
    }
  }, []);
  return /*#__PURE__*/_jsx("article", {
    className: "flex flex-wrap gap-2",
    children: Object.entries(icons).map(_ref => {
      var [key, {
        path,
        callback,
        color,
        type
      }] = _ref;

      var Component = () => /*#__PURE__*/_jsx("svg", {
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: path
      });

      if (type == "a") {
        var href = callback(_extends({
          url
        }, props));
        return /*#__PURE__*/_jsx("a", {
          href: href,
          "aria-label": "Share via " + key,
          className: classes,
          target: "_blank",
          children: /*#__PURE__*/_jsx(Component, {})
        }, key);
      }

      return /*#__PURE__*/_jsx("button", {
        onClick: () => callback(_extends({
          url
        }, props)),
        "aria-label": "Share via " + key,
        className: classes,
        children: /*#__PURE__*/_jsx(Component, {})
      }, key);
    })
  });
};

var useSocialLinksClasses = props => {
  var classes = useButtonClass({
    color: props.color
  });
  return clsx(classes, "rounded-full p-1.5 h-8 w-8");
};
//# sourceMappingURL=index.js.map